import { useState, useEffect } from 'react';
import { ToastContainer, toast, Slide, Zoom, Flip, Bounce } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import Default from './Components/layout/Default';
import Grid1 from './Components/layout/Grid1';
import Grid2 from './Components/layout/Grid2';
import Grid3 from './Components/layout/Grid3';
import Grid4 from './Components/layout/grid4';
import Toastify from './Components/layout/Toastify';
// import Carousel from './Components/layout/Carousel';
import icons from './utils/icons';
import { getFBFormattedData, getGoogleFormattedData, getYelpFormattedData } from './utils/functions';
import useFetch from './hooks/useFetch';
import Masonry from './Components/layout/Masonry';

const ReviewsFrontEnd = (props) => {
	const { attributes, reFetch } = props;
	const { columns, layout, isReviewType: isEnabled, ratingIconColors, isToast, toastPosition, toastAnimation, toastDuration } = attributes;
	const { google, yelp, facebook } = ratingIconColors;
	const { reviews, allReviews, loading } = useFetch(isEnabled);
	const [toastId, setToastId] = useState(null);
	const [toastIndex, setToastIndex] = useState(0);

	useEffect(() => {
		if (!loading && allReviews?.length > 0 && isToast) {
			if (toastId) {
				toast.dismiss(toastId);
			}

			const review = allReviews[toastIndex >= allReviews?.length ? 0 : toastIndex];
			const data = review?.author_url ? getGoogleFormattedData(review, google) :
				review?.id ? getYelpFormattedData(review, yelp) :
					review?.reviewer ? (getFBFormattedData(review, facebook)) :
						{};

			const id = toast(<Toastify review={data} attributes={attributes} />, {
				position: toastPosition,
				autoClose: parseInt(toastDuration),
				className: 'notification',
				hideProgressBar: true,
				transition: toastAnimation === 'Slide' ? Slide :
					toastAnimation === 'Flip' ? Flip :
						toastAnimation === 'Zoom' ? Zoom :
							Bounce,
				onClose: () => {
					setToastIndex((prev) => allReviews.length - 1 <= toastIndex ? 0 : prev + 1);
				}
			});
			setToastId(id);

		}

	}, [isToast, loading, toastIndex]);


	if (loading || reFetch) {
		return <div className='grbbPreloader'>{icons.preLoader}</div>
	}


	return <> <div className={`grbbBusinessReview ${layout} columns-${columns.desktop} columns-tablet-${columns.tablet} columns-mobile-${columns.mobile}`}>

		{'default' === layout &&
			<Default attributes={attributes} reviews={reviews} />
		}
		{'grid1' === layout &&
			<Grid1 attributes={attributes} reviews={reviews} />
		}
		{'grid2' === layout &&
			<Grid2 attributes={attributes} reviews={reviews} />
		}
		{'grid3' === layout &&
			<Grid3 attributes={attributes} reviews={reviews} />
		}
		{'grid4' === layout &&
			<Grid4 attributes={attributes} reviews={reviews} />
		}
		{'masonry' === layout &&
			<Masonry attributes={attributes} reviews={reviews} />
		}

		{/* {'slider' === layout &&
			<Carousel reviews={reviews} allReviews={allReviews} loading={loading} attributes={attributes} />
		} */}
	</div>
		<ToastContainer />
	</>
}
export default ReviewsFrontEnd